import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './EmailConfirmation.css';

/**
 * Страница подтверждения email
 */
const EmailConfirmation = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [isEmailSent, setIsEmailSent] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Секции для навигации в Header
  const sections = [
    { id: 'hero', label: 'Home' },
    { id: 'testimonial', label: 'About Us' },
    { id: 'legal-help', label: 'Services' },
    { id: 'success-stories', label: 'Success Stories' },
    { id: 'features', label: 'Features' }
  ];

  const handleSendEmail = (e) => {
    e.preventDefault();
    console.log('Sending confirmation email to:', email);
    // Здесь будет логика отправки email
    setIsEmailSent(true);
    
    // Переход на страницу тарифов через 2 секунды
    setTimeout(() => {
      navigate('/pricing-plans');
    }, 2000);
  };

  return (
    <div className="email-confirmation-page">
      <Header sections={sections} onJoinClick={openModal} />
      
      {/* Фон с зелеными кругами */}
      <div className="confirmation-background">
        <div className="confirmation-circle confirmation-circle-1"></div>
        <div className="confirmation-circle confirmation-circle-2"></div>
        <div className="confirmation-circle confirmation-circle-3"></div>
      </div>

      {/* Центральное окно с подтверждением */}
      <main className="confirmation-container">
        <div className="confirmation-box">
          {!isEmailSent ? (
            <>
              <h1 className="confirmation-title">
                It's almost done!<br />
                We will contact<br />
                you via email.
              </h1>
              
              <form className="confirmation-form" onSubmit={handleSendEmail}>
                <div className="form-group">
                  <label htmlFor="email">Is this your correct email?</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="example@email.com"
                    required
                  />
                </div>
                
                <button type="submit" className="send-button">
                  Send
                </button>
              </form>
            </>
          ) : (
            <div className="success-message">
              <div className="success-icon">✓</div>
              <h2 className="success-title">Email Sent Successfully!</h2>
              <p className="success-text">
                Confirmation email has been sent to<br />
                <strong>{email}</strong>
              </p>
              <p className="success-subtext">
                Please check your inbox and follow the instructions to complete your registration.
              </p>
            </div>
          )}
        </div>
      </main>

      <Footer />

      {/* Modal Window */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title">Are you sure you want to continue?</h3>
            <div className="modal-buttons">
              <button className="modal-confirm-button" onClick={() => { closeModal(); navigate('/contact-form'); }}>
                Yes
              </button>
              <button className="modal-cancel-button" onClick={closeModal}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmailConfirmation;
